module.exports = __webpack_public_path__ + "static/media/Jorah Mormont 1.45627327.jpg";